import config from "site-config";
import { fetchJSON } from "lib/fetch";
import { useQuery, QueryConfig } from "react-query";

export const LINE_SHEET_LOGO = "LINE_SHEET_LOGO";

interface IBase {
    branding: object;
    enabled: boolean;
    seats: number;
}

interface IModules {
    base: IBase;
    api: object;
    drive: object;
}

interface IResponse {
    modules: IModules;
    settings: object;
    merchant_id: string;
    modified_on: string;
}

export const useSetLineSheetLogo = (type: string, image: string, options?: QueryConfig<IResponse>) => {
    return useQuery<IResponse>(
        [LINE_SHEET_LOGO, type],
        () =>
            fetchJSON<IResponse>(`${config.api}/brand/branding`, {
                method: "POST",
                body: `${type}=${image}`,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                },
                noDomain: true,
            }).then((responseJson) => responseJson),
        options
    );
};
